(function (mod) {
	if (typeof exports === "object") {
		module.exports = mod();
	}else{
		window.Mo = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ Constellation Class ↓
/////////////////////////////////////////////////////////////////////////
var Star=require('./cjs.Star.js');
var sprite;
var starMatrix,nameMatrix;
    
var S=function(C,clsN,parts,name,npos){
    this.constellation=new createjs.Container();
    this.constellation2=new createjs.Container();
    
    //星の配置
    this.stars=[];
    this.stars2=[];
    var smx=starMatrix[clsN].stars;
    var mlist=[];
    for(var j=0;j<parts.length;j++){//stars
        if(mlist.indexOf(parts[j])<0){
            mlist.push(parts[j]);
            s=smx[parts[j]];
            ss=new Star(C,sprite[s[3]-1],{index:s[0],x:C.rx(s[1]),y:C.ry(s[2]),level:s[3],addscale:1.0});
            sss=new Star(C,sprite[s[3]-1],{index:s[0],x:C.rx(s[1]),y:C.ry(s[2]),level:s[3],addscale:1.0});
            this.stars.push(ss);
            this.constellation.addChild(ss.star);
            this.stars2.push(sss);
            this.constellation2.addChild(sss.star);
        }
    }
    
    //線の描画
    this.lines=[];
    this.lines2=[];
    var i=0;
    var llist=[];
    var x,y,w,h;
    while(i<parts.length-1){
        var p=smx[parts[i]];
        var s=smx[parts[i+1]];
        //重複チェック
        if((llist.indexOf(p+","+s)<0)&&(llist.indexOf(s+","+p)<0)){
            llist.push(p+","+s);
            this.line = new createjs.Shape();
            this.line.graphics.setStrokeStyle(C.size.baseScale,1,1,false);
            this.line.graphics.beginStroke("rgba(255,255,255,0.8)");
            this.line.graphics.dashedLineTo(C.rx(p[1]),C.ry(p[2]),C.rx(s[1]),C.ry(s[2]),C.size.baseScale*2);
            this.line.graphics.endStroke();
            this.line.alpha=0;
            this.lines.push(this.line);
            this.line2=this.line.clone();
            this.lines2.push(this.line2);
            this.constellation2.addChild(this.line2);
            this.constellation.addChild(this.line);
        }
        i++;
    }
    //this.line.cache(gb.x,gb.y,gb.width,gb.height);
    
    
    //名前
    this.name= new createjs.Text(name,C.size.baseScale*6+"px Pinyon Script","#fff");
    //var domElement = new createjs.DOMElement(htmlElement);
    gb=this.name.getBounds();
    this.name.set({
        regX:gb.width/2,
        regY:gb.height/2,
        x:C.rx(nameMatrix[npos][0]),
        y:C.ry(nameMatrix[npos][1])
    })
    this.name.textBaseline = "top";
    this.name.cache(gb.x,gb.y,gb.width,gb.height);
    this.name2=this.name.clone();
    this.constellation2.addChild(this.name2);
    this.name.alpha=0.0;
    this.constellation.addChild(this.name);
    this.constellation.alpha=0;
    
    var cb=this.constellation.getBounds();
    Q.info(cb);
    
    this.constellation2.set({
        regX:cb.x+cb.width/2,
        regY:cb.y+cb.height/2,
        x:0,
        y:0,
        scaleX:2.5,
        scaleY:2.5,
        alpha:1.0
    })
    
}
S.set =function(C,S,queue,stmx,nmmx){
    sprite=[queue.getResult("s1"),queue.getResult("s2"),queue.getResult("s3"),queue.getResult("s4"),queue.getResult("s5")];
    starMatrix=stmx;
    nameMatrix=nmmx;
};


    
createjs.Graphics.prototype.dashedLineTo = function( x1 , y1 , x2 , y2 , dashLen ){
    this.moveTo( x1 , y1 );

    var dX = x2 - x1;
    var dY = y2 - y1;
    var dashes = Math.floor(Math.sqrt( dX * dX + dY * dY ) / dashLen );
    var dashX = dX / dashes;
    var dashY = dY / dashes;

    var q = 0;
    while( q++ < dashes ){
        x1 += dashX;
        y1 += dashY;
        this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x1, y1);
    }
    this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x2, y2);
    return this;
}


S.prototype.up=function(step,max){
	//O.put("count",this.count);
    for(var i=0;i<this.stars.length;i++){
        this.stars[i].up(step,max);
    }
    this.name.rotation+=-0.05;
}

S.prototype.up2=function(step,max){
	//O.put("count",this.count);
    for(var i=0;i<this.stars2.length;i++){
        this.stars2[i].up(step,max);
    }
    this.constellation2.rotation+=-0.1
    this.name2.rotation+=0.1;
}

S.prototype.view=function(i){
    this.delay=i*(420-i*10)-_.random(0,i)*i;
    this.constellation.alpha=0.0;
    this.tween=createjs.Tween.get(this.constellation,{loop:false,override:true})
       .wait(this.delay)
        .call(this.viewStars.bind(this))
        .call(this.drawline.bind(this))
        .call(this.viewName.bind(this))
        .wait(1000).to({alpha:1.0},500)
        .wait(12000).to({alpha:0.0},1500);
}

S.prototype.view2=function(i){
    this.delay=i*(420-i*10)-_.random(0,i)*i;
    this.constellation2.alpha=0.0;
    this.tween=createjs.Tween.get(this.constellation2,{loop:false,override:true})
        .call(this.viewStars2.bind(this))
        .call(this.drawline2.bind(this))
        .call(this.viewName2.bind(this))
        .wait(0).to({alpha:1.0},500)
}
S.prototype.drawline=function(){
    for(var i=0;i<this.lines.length;i++){
        this.lines[i].alpha=0.0;
        this.tween=createjs.Tween.get(this.lines[i],{loop:false,override:true})
           .set({alpha:0.0}).wait(i*200+1500).to({alpha:0.8},300).to({alpha:0.7},300);
    }
}
S.prototype.viewStars=function(){
    for(var i=0;i<this.stars.length;i++){
        this.stars[i].star.alpha=0.0;
        this.tween=createjs.Tween.get(this.stars[i].star,{loop:false,override:true})
           .set({alpha:0.0}).wait(i*190+1700).to({alpha:1.0},200).to({alpha:0.7},300);
    }
}
S.prototype.viewName=function(){
        this.name.alpha=0.0;
        this.tween=createjs.Tween.get(this.name,{loop:false,override:true})
           .set({alpha:0.0}).wait(2500).to({alpha:1.0},2000);
}


S.prototype.drawline2=function(){
    for(var i=0;i<this.lines2.length;i++){
        this.lines2[i].alpha=0.0;
        this.tween=createjs.Tween.get(this.lines2[i],{loop:false,override:true})
           .set({alpha:0.0}).wait(i*200+1500).to({alpha:0.8},300).to({alpha:0.7},300);
    }
}
S.prototype.viewStars2=function(){
    for(var i=0;i<this.stars2.length;i++){
        this.stars2[i].star.alpha=0.0;
        this.tween=createjs.Tween.get(this.stars2[i].star,{loop:false,override:true})
           .set({alpha:0.0}).wait(i*190+1700).to({alpha:1.0},200).to({alpha:0.7},300);
    }
}
S.prototype.viewName2=function(){
        this.name2.alpha=0.0;
        this.tween=createjs.Tween.get(this.name2,{loop:false,override:true})
           .set({alpha:0.0}).wait(2500).to({alpha:1.0},2000);
}


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return S;
/////////////////////////////////////////////////////////////////////////

})();
return Mo;
});


